import { Link, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { to: '/owner/dashboard', icon: '📊', label: 'Dashboard' },
  { to: '/owner/orders', icon: '📦', label: 'Orders' },
  { to: '/owner/menu', icon: '📋', label: 'Menu' },
  { to: '/owner/scan', icon: '📷', label: 'Scan' },
];

export default function OwnerBottomNav() {
  const location = useLocation();
  const isTestMode = location.pathname.startsWith('/__test__/');
  const prefix = isTestMode ? '/__test__' : '';

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 bg-white dark:bg-slate-800 border-t border-slate-200 dark:border-slate-700 safe-area-inset-bottom">
      <div className="max-w-screen-md mx-auto flex items-center justify-around py-2">
        {NAV_ITEMS.map((item) => {
          const to = prefix + item.to;
          const isActive = location.pathname === to;
          return (
            <Link
              key={item.to}
              to={to}
              className={`flex flex-col items-center gap-0.5 px-4 py-2 rounded-lg min-w-[64px] transition-colors ${
                isActive
                  ? 'text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/20'
                  : 'text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700'
              }`}
            >
              <span className="text-xl">{item.icon}</span>
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
